<template>
  <div>
    <button
      @click.prevent="onClick"
      class="flex items-center justify-center w-48 h-48 p-2 bg-white border border-gray-300 hover:border-green-500"
    >
      <template v-if="isImage">
        <div class="flex flex-col items-center">
          <div class="flex-1">
            <img
              class="max-h-36"
              loading="lazy"
              :src="`${baseUrl}supportattachmentdata?id=${
                attachment.id
              }&inline=true&authtoken=${encodeURIComponent(token)}`"
            />
          </div>
          <div class="pt-1 text-xs leading-none flex-0">
            {{ attachment.name }}
          </div>
        </div>
      </template>

      <template v-else>
        <span v-html="$tk('Common.General.File').toLowerCase()"></span>
      </template>
    </button>

    <portal to="modals">
      <div
        class="fixed inset-0 z-30 flex items-center justify-center p-10 bg-black bg-opacity-75"
        v-if="isZoomed"
      >
        <button
          class="absolute z-30 flex items-center justify-center w-10 h-10 text-gray-900 bg-gray-200 rounded-full shadow-xl top-10 right-10 hover:bg-white focus:bg-white focus:outline-none"
          @click="isZoomed = null"
        >
          <font-awesome-icon :icon="['far', 'times']" />
        </button>
        <img
          class="shadow-lg select-none"
          :src="`${baseUrl}supportattachmentdata?id=${
            attachment.id
          }&inline=true&authtoken=${encodeURIComponent(token)}`"
          alt=""
        />
      </div>
    </portal>
  </div>
</template>

<script>
import TokenService from "@/services/TokenService";
import { getConfig } from "@/config";

const config = getConfig();

export default {
  name: "p-support-attachment",

  props: {
    attachment: {
      type: Object,
      requred: true,
    },
  },
  data() {
    return {
      isZoomed: false,
    };
  },
  computed: {
    token() {
      return TokenService.getToken();
    },
    isImage() {
      return this.attachment.type.indexOf("image/") === 0;
    },
    baseUrl() {
      return config?.apiUrl;
    },
  },
  methods: {
    onClick() {
      if (this.isImage) {
        this.isZoomed = true;
      } else {
        var element = document.createElement("a");
        element.setAttribute(
          "href",
          `${config?.apiUrl}supportattachmentdata?id=${
            this.attachment.id
          }&inline=true&authtoken=${encodeURIComponent(this.token)}`
        );
        element.setAttribute("download", this.attachment.name);
        element.setAttribute("target", "_blank");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    },
  },
};
</script>